import { categoricalColorAt } from "../../../../utils/categoricalColors";
import { ReviewBucket } from "../../network/networkMath";
import type { AuditDestination } from "../auditSubTabs";

export type ReviewBucketView = { bucket: ReviewBucket; labelKey: string; color: string; destination: AuditDestination };

const BUCKETS_IN_ORDER: readonly Omit<ReviewBucketView, "color">[] = [
	{ bucket: ReviewBucket.LongShifts, labelKey: "pbj_model.network.summary.bucket.long_shifts", destination: "long_shifts" },
	{ bucket: ReviewBucket.Unmapped, labelKey: "pbj_model.network.summary.bucket.unmapped", destination: "submission" },
	{ bucket: ReviewBucket.AfterTermination, labelKey: "pbj_model.network.summary.bucket.after_termination", destination: "terminated" },
	// The daily-cap trims are listed at the bottom of the Long Shifts tab.
	{ bucket: ReviewBucket.Capped, labelKey: "pbj_model.network.summary.bucket.capped", destination: "long_shifts" },
	{ bucket: ReviewBucket.ShortShifts, labelKey: "pbj_model.network.summary.bucket.short_shifts", destination: "short_shifts" },
];

/** The hero's review buckets in display order, each with its legend label, colour and the list it opens. */
export const REVIEW_BUCKET_VIEWS: readonly ReviewBucketView[] = BUCKETS_IN_ORDER.map((view, index) => ({ ...view, color: categoricalColorAt(index).dot }));

export const reviewBucketView = (bucket: ReviewBucket): ReviewBucketView => {
	const view = REVIEW_BUCKET_VIEWS.find((candidate) => candidate.bucket === bucket);
	if (!view) throw new Error(`No Summary view for review bucket ${bucket}`);
	return view;
};
